import { createSelector } from '../dependencies';

export const leftPanelOpenSelector = state => state.app.leftPanelOpen;
